<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <div class="left_tit">
        建立了標準化的知識産權服務流程和規範，利用互聯網技術實現案件的智能化管理和案件進度信息的實時自動推送，有效提昇服務效率和透明度，讓客戶隨時了解業務進展
      </div>
      <ul class="left_desc">
        <li>
          首創"知識産權大數據共享經濟"
          運營模式，依託萬知雲知識産權管理系統、萬知共享獨立商城系統、萬知數據交互系統、萬知深度檢索分析服務系統等四大服務體繫，為各類客戶提供全面系統的知識産權資源運營解決方案，以大數據為支撐，精準匹配資源，解決行業資源配置難題。
        </li>
      </ul>
      <div class="left_card">
        <div class="card_item" v-for="(item, index) in cardList" :key="index">
          <div @click="changeRouter(index)" class="card_content">
            <i :class="item.icon" class="iconfont"></i>
            <el-tooltip
              :content="item.txt"
              :disabled="item.txt.length <= 6"
              placement="top"
            >
              <span class="item_txt" :class="{ ellipsis: item.txt.length > 5 }">
                {{ item.txt }}
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="one_right">
      <img src="@/assets/img/banner/qiehuan1.jpg" alt="" />
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: "icon-chanyelian-shengwuyiyao",
          txt: "科硏"
        },
        {
          icon: "icon-shengchanzhizao",
          txt: "Science Exploration"
        },
        {
          icon: "icon-lvye",
          txt: "網文出海"
        },
        {
          icon: "icon-zu",
          txt: "大秦農夫"
        },
        {
          icon: "icon-xinnengyuan",
          txt: "商標"
        },
        {
          icon: "icon-dc-icon-xinxijishu",
          txt: "科硏項目申報"
        },
        {
          icon: "icon-jienenghuanbao",
          txt: "版權"
        },
        {
          icon: "icon-shuzichuangyi",
          txt: "專利"
        },
        {
          icon: "icon-fenzishi",
          txt: "科技服務業務"
        }
      ]
    };
  },
  methods: {
    changeRouter(index) {
      switch (index) {
        case 0:
          this.$router.push("/kyDetail").catch(v => {});
          break;
        case 1:
          this.$router.push("/SeDetail").catch(v => {});
          break;
        case 2:
          this.$router.push("/WangInfo").catch(v => {});
          break;
        case 3:
          this.$router.push("/daqin").catch(v => {});
          break;
        case 4:
          this.$router.push("/copyrightInfo").catch(v => {});
          break;
        case 5:
          this.$router.push("/projectInfo").catch(v => {});
          break;
        case 6:
          this.$router.push("/rightInfo").catch(v => {});
          break;
        case 7:
          this.$router.push("/patentInfo").catch(v => {});
          break;
        case 8:
          this.$router.push("/serviceInfo").catch(v => {});
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.core_one_wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 30px;
  padding: 2rem 0;
  width: 100%;
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;

  // 超大屏适配
  @media screen and (min-width: 1920px) {
    max-width: 2560px;
    padding: 3rem 0;
  }

  // 大屏适配
  @media screen and (min-width: 1440px) and (max-width: 1919px) {
    max-width: 1600px;
  }

  // 平板和小屏电脑
  @media screen and (max-width: 1024px) {
    flex-direction: column;
    padding: 1.5rem 0;
  }

  // 手机横屏
  @media screen and (max-width: 768px) {
    padding: 1rem 0;
  }

  // 手机竖屏
  @media screen and (max-width: 576px) {
    padding: 0.5rem 0;
  }

  .one_left {
    width: 60%;
    padding: 0 2rem;
    box-sizing: border-box;

    @media screen and (min-width: 1920px) {
      width: 55%;
      padding: 0 3rem;
    }

    @media screen and (max-width: 1024px) {
      width: 100%;
      padding: 0 1.5rem;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      padding: 0 1rem;
    }

    @media screen and (max-width: 576px) {
      padding: 0 0.75rem;
    }

    .left_tit {
      font-size: 1.4rem;
      font-weight: bold;
      color: #3e3e3e;
      line-height: 1.5;
      word-break: break-word;

      @media screen and (min-width: 1920px) {
        font-size: 1.8rem;
      }

      @media screen and (max-width: 1024px) {
        font-size: 1.2rem;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
        margin-top: 1.25rem;
      }

      @media screen and (max-width: 576px) {
        font-size: 1rem;
      }
    }

    .left_desc {
      color: #717171;
      padding: 1.25rem 2.5rem 1.5rem 2.5rem;
      box-sizing: border-box;

      @media screen and (min-width: 1920px) {
        padding: 1.5rem 3rem 2rem 3rem;
        font-size: 1.1rem;
      }

      @media screen and (max-width: 1024px) {
        padding: 1rem 1.5rem;
        font-size: 1rem;
      }

      @media screen and (max-width: 768px) {
        padding: 1rem 0;
        font-size: 0.95rem;
      }

      @media screen and (max-width: 576px) {
        font-size: 0.9rem;
      }

      li {
        line-height: 1.8;
        word-break: break-word;

        @media screen and (min-width: 1920px) {
          line-height: 2;
          font-size: 1.1rem;
        }

        @media screen and (max-width: 1024px) {
          line-height: 1.6;
          font-size: 1rem;
        }

        @media screen and (max-width: 768px) {
          line-height: 1.5;
          font-size: 0.95rem;
        }

        @media screen and (max-width: 576px) {
          font-size: 0.9rem;
        }
      }
    }

    .left_card {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-top: 1.5rem;
      gap: 1rem;

      @media screen and (min-width: 1920px) {
        margin-top: 2rem;
        gap: 1.5rem;
      }

      @media screen and (max-width: 1024px) {
        margin-top: 1.25rem;
        gap: 0.75rem;
      }

      @media screen and (max-width: 768px) {
        margin: 1rem 0 0 0;
        gap: 0.5rem;
      }

      @media screen and (max-width: 576px) {
        gap: 0.4rem;
      }

      .card_item {
        box-sizing: border-box;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
          0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        color: #0991d3;
        padding: 0 1rem;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.3s ease;

        // 大屏 - 3 列
        @media screen and (min-width: 1440px) {
          width: calc(33.333% - 0.667rem);
          height: 55px;
        }

        // 中屏 - 3 列
        @media screen and (min-width: 1025px) and (max-width: 1439px) {
          width: calc(33.333% - 0.667rem);
          height: 50px;
        }

        // 平板 - 3 列
        @media screen and (min-width: 769px) and (max-width: 1024px) {
          width: calc(33.333% - 0.667rem);
          height: 48px;
        }

        // 手机横屏 - 2 列
        @media screen and (max-width: 768px) {
          width: calc(50% - 0.375rem);
          height: 45px;
          padding: 0 0.75rem;
        }

        // 手机竖屏 - 2 列
        @media screen and (max-width: 576px) {
          width: calc(50% - 0.3rem);
          height: 42px;
          padding: 0 0.5rem;
        }

        i {
          font-size: 1.3rem;
          flex-shrink: 0;

          @media screen and (min-width: 1920px) {
            font-size: 1.6rem;
          }

          @media screen and (max-width: 768px) {
            font-size: 1.1rem;
          }

          @media screen and (max-width: 576px) {
            font-size: 1rem;
          }
        }

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(9, 145, 211, 0.2);

          .item_txt {
            letter-spacing: 1px;
          }
        }

        .card_content {
          display: flex;
          align-items: center;
          width: 100%;
          overflow: hidden;
        }

        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 1rem;
          margin-left: 0.625rem;
          transition: all 0.3s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          @media screen and (min-width: 1920px) {
            font-size: 1.2rem;
          }

          @media screen and (max-width: 1024px) {
            font-size: 0.95rem;
          }

          @media screen and (max-width: 768px) {
            font-size: 0.85rem;
            margin-left: 0.5rem;
          }

          @media screen and (max-width: 576px) {
            font-size: 0.8rem;
          }

          &.ellipsis {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .one_right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    @media screen and (min-width: 1920px) {
      width: 35%;
    }

    @media screen and (max-width: 1024px) {
      width: 100%;
      margin-top: 1.5rem;
      padding: 0;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 1rem;
    }

    @media screen and (max-width: 576px) {
      margin-top: 0.75rem;
    }

    img {
      width: 80%;
      max-width: 400px;
      height: auto;
      object-fit: contain;
      margin-top: 2rem;
      transition: all 0.3s ease;

      @media screen and (min-width: 1920px) {
        width: 90%;
        max-width: 600px;
        margin-top: 3rem;
      }

      @media screen and (max-width: 1024px) {
        width: 60%;
        max-width: 350px;
        margin-top: 1rem;
      }

      @media screen and (max-width: 768px) {
        width: 70%;
        max-width: 280px;
      }

      @media screen and (max-width: 576px) {
        width: 80%;
        max-width: 220px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core_competence/CoreItemOne.vue